<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
<div *ngIf="!isLoading">
  <sm-booking-details
    *ngIf="isAnyBooking != undefined && booking"
    [booking]="booking"
    [title]="title"
    [fromSummary]="true"
    [anyBooking]="isAnyBooking"
    [subTitle]="subTitle"
    (photoUpdate)="onPhotoUpdate($event)"
    showDeleteButton="false"
  ></sm-booking-details>

  <div>
    <salonmonster-stripe-payment
      *ngIf="clientBookingPayments"
      (onBookingSave)="onBookingSave()"
      [refreshStripe]="refreshStripe"
      [booking]="booking"
      [(savingStripe)]="savingStripe"
      [errorOccurredWhileSaving]="enableBookButton"
    ></salonmonster-stripe-payment>
  </div>
  <div
    sm-center
    class="margin-top-20"
    *ngIf="!clientBookingPayments || !this.userService.isLoggedIn()"
  >
    <button
      mat-raised-button
      class="smc-button-large smc-button-primary"
      [disabled]="!enableBookButton"
      (click)="onBookingSave()"
    >
      <ng-container *ngIf="this.userService.isLoggedIn()">{{ 'BOOKINGS.BOOK_IT' | translate }}</ng-container>
      <ng-container *ngIf="!this.userService.isLoggedIn() && clientBookingPayments">{{ 'BOOKINGS.LOG_IN_TO_BOOK' | translate }}</ng-container>
      <ng-container *ngIf="!this.userService.isLoggedIn() && !clientBookingPayments">{{ 'BOOKINGS.LOG_IN_AND_BOOK' | translate }}</ng-container>
    </button>
  </div>

  <br />
  <br />
  <br />
  <br />
</div>
